import { useRef } from 'react';

/** Latches to true the first time the condition is true and stays true for the component's lifetime. */
export default function useEverTrue(condition: boolean): boolean {
    const everTrue = useRef(false);
    if (condition) {
        everTrue.current = true;
    }
    return everTrue.current;
}
